import { QueueManagementConstants } from '../../queueManagement/QueueManagementConstants';
export class PriorityRuleUtilsService {
    static convertExtras(property) {
        let extrasProperty = property;
        if (property?.includes(QueueManagementConstants.EXTRAS)) {
            const tokens = extrasProperty.split('.').slice(2);
            extrasProperty = tokens.join('.');
        }
        return extrasProperty;
    }
    static serializeExtrasProperies(property) {
        return `Contact.Extras.${property}`;
    }
}
